import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row, Table } from 'react-bootstrap';
import { Trans } from 'react-i18next';
import { ProductContext } from 'context/Context';

const OrderedProducts = ({ order }) => {
  const {
    productsState: {
      config: { currency }
    }
  } = useContext(ProductContext);

  const orderedProductsData = order.details ?? [];

  const subtotal = orderedProductsData.reduce(
    (acc, curr) => curr.quantity * curr.rate + acc,
    0
  );

  const shipping = 0;

  return (
    <Card className="mb-3">
      <Card.Body>
        <div className="table-responsive fs--1">
          <Table striped className="border-bottom">
            <thead className="bg-200 text-900">
              <tr>
                <th className="border-0 text-nowrap">
                  <Trans ns="commerce">Product</Trans>
                </th>
                <th className="border-0 text-center text-nowrap">
                  <Trans ns="commerce">Quantity</Trans>
                </th>
                <th className="border-0 text-end text-nowrap d-none d-lg-table-cell">
                  <Trans ns="commerce">Rate</Trans>
                </th>
                <th className="border-0 text-end text-nowrap">
                  <Trans ns="commerce">Amount</Trans>
                </th>
              </tr>
            </thead>
            <tbody>
              {orderedProductsData.map(product => (
                <tr key={product.id} className="border-200">
                  <td className="align-middle">
                    <h6 className="mb-0">{product.name}</h6>
                    {/** 
                    <p className="mb-0">{product.description}</p>
                    */}
                  </td>
                  <td className="align-middle text-center">
                    {product.quantity}
                  </td>
                  <td className="align-middle text-end d-none d-lg-table-cell">
                    {currency}
                    {parseFloat(product.rate).toLocaleString(undefined, {
                      maximumFractionDigits: 2,
                      minimumFractionDigits: 2
                    })}
                  </td>
                  <td className="align-middle text-end">
                    {currency}
                    {parseFloat(product.quantity * product.rate).toLocaleString(
                      undefined,
                      { maximumFractionDigits: 2, minimumFractionDigits: 2 }
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Row className="g-0 justify-content-end">
            <Col xs="auto">
              <Table borderless size="sm" className="fs--1 text-end">
                <tbody>
                  <tr>
                    <th className="text-900">
                      <Trans ns="commerce">Subtotal</Trans>:
                    </th>
                    <td className="fw-semi-bold">
                      {currency}
                      {parseFloat(subtotal).toLocaleString(undefined, {
                        maximumFractionDigits: 2,
                        minimumFractionDigits: 2
                      })}
                    </td>
                  </tr>
                  <tr>
                    <th className="text-900">
                      <Trans ns="commerce">Shipping</Trans>:
                    </th>
                    <td className="fw-semi-bold">
                      {shipping && (
                        <>
                          {currency}
                          {parseFloat(shipping).toLocaleString(undefined, {
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2
                          })}
                        </>
                      )}
                    </td>
                  </tr>
                  <tr className="border-top">
                    <th className="text-900">
                      <Trans ns="commerce">Total</Trans>:
                    </th>
                    <td className="fw-semi-bold">
                      {currency}
                      {parseFloat(subtotal + shipping).toLocaleString(
                        undefined,
                        {
                          maximumFractionDigits: 2,
                          minimumFractionDigits: 2
                        }
                      )}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
        </div>
      </Card.Body>
    </Card>
  );
};

OrderedProducts.propTypes = {
  order: PropTypes.object
};

export default OrderedProducts;
